export default {
      id: "whatsapp-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }